require('./helpers/bundle-manifest').register(JSON.parse("{\"3MPdb\":\"chat-loader.js\",\"jvVOn\":\"call-data.b80c1a49.js\"}"));